import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';


//Styles

import '../styles/chapter_one.scss';
import '../styles/transition-inner-chapter.scss';
import '../styles/transition-group.scss';
import '../styles/transition-fadeDown.scss';

import '../styles/main-nav.scss';
import '../styles/audio-element.scss';
import '../styles/video.scss';
import '../styles/timeline.scss';

//Components
import './assetLoader';
import Shareelement from './shareelement';
import Warenkorb from './warenkorb_menu';

import Timeline from './timeline';
import ChapterNavi from './chapter_navi';
import Loaderelement from './loaderelement';

import Iconset from './icons';
import Pause_menu from './pause_menu';

import Test from './test';
import Mobile_Chapter_one from './mobile_chapter_one';


import TwitterFallback from './twitter_fallback';

import LoadingScreen from './loading_screen';
import Intro from './intro';
import IntroScreen from './introScreen';
import SpaceVideo from './spaceVideo';
import LiveSession from './livesession';
import Staticvideo from './staticVideo';
import Outro from './outro-screen';


//___________________________________________________ Innerchapter Switch



function GetInnerChapter(props){
	switch(props.chapter){
		case 0:
			return (<SpaceVideo 
								timeupdate = {props.timeupdate}
								changeActiveVideo={props.changeActiveVideo}
								activeVideo = {props.activeVideo}
								//
								showNote={props.showNote}
								//
								timecode={props.timecode}
								isPlaying={props.isPlaying}
								mainPlay={props.mainPlay} 
								//
								getCurrentTimeCode={props.getCurrentTimeCode}
								loadStatus={props.loadStatus}

								firstSession={props.firstSession}
								secondSession={props.secondSession}

								ended={props.ended}/>);
		break;
		
		case 1:
			return (<Staticvideo 
								timeupdate = {props.timeupdate}
								timecode={props.timecode}
								ended = {props.ended}
								isPlaying ={props.isPlaying}
								src={_assets.loaded.introVideo}
								mainPlay={props.mainPlay}
								getCurrentTimeCode={props.getCurrentTimeCode} />);
		break;
		case 2:
			return ( <LiveSession 
								timeupdate = {props.timeupdate}
								timecode={props.timecode}
								ended = {props.ended}
								isPlaying ={props.isPlaying}
								mainPlay={props.mainPlay}
								src={_assets.loaded.introVideo}
								getCurrentTimeCode={props.getCurrentTimeCode} />);
		break;
		case 'load':
			return (<LoadingScreen
					loadStatus={props.loadStatus}
					firstSession={props.firstSession}
					secondSession={props.secondSession}
					goToInnerChapterAfterLoad={props.goToInnerChapterAfterLoad}/>);
		break;

		case 'mobile':
			return (<Mobile_Chapter_one 
								loadStatus={props.loadStatus}
								firstSession={props.firstSession}
								secondSession={props.secondSession}
								wifiWasVisible={props.wifiWasVisible}
								wifiAction= {props.wifiAction}
								chapter={1} />);
		break;
	}	
}

//___________________________________________________ Chapter 1

class Chapter_One extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			currentPercentage : 0,
			currentInnerChapterTime : 0,
			showNote: true,
			showIntro:true,
			innerChapter : _assets.test,//switch to innerchapter
			isLoading : true,
			spaceActive : true,
			timeoffset : 0,
			activeVideo:0,
			realTime :0,
			offsettime:0,
			timecode:0,
			isMobile : _assets.isMobile,
			isPlaying:false,
			//loading Status
			loadStatus:0,
			firstSession : false,
			secondSession : false,
			goToChapterAfterLoading : 0,

			hash : ''
		}

		this.props.updateFunction();
		_assets.loadAssets();

		if(_assets.isMobile){
			this.setState({
				goToChapterAfterLoading : 'mobile'
			});
		}
	}

	setHash(forChapter){
    var hashForChapter = '';
    switch(forChapter){
      case 0:
        hashForChapter = 'intro';
      break;
      case 1:
        hashForChapter = 'introsession';
      break;
      case 2:
        hashForChapter = 'livesession';
      break;
      case 'mobile':
        hashForChapter = 'mobile';
      break;
    }

    window.location.hash = hashForChapter;

    this.setState({
      hash : hashForChapter
    });
  }


	getInnerChapterFromHash(hash){

		//console.log('get hash getInnerChapterFromHash', hash);
		var goToInnerChapter = 0;
		switch(hash){
			 case 'intro':
        goToInnerChapter = 0;
      break;
      case  'introsession':
        goToInnerChapter = 1;
      break;
      case 'livesession':
        goToInnerChapter = 2;
      break;
      case 'mobile':
        goToInnerChapter = 'mobile';
      break;
      default:
      	goToInnerChapter = 0;
      break;
		}

		this.setState({
			goToChapterAfterLoading : goToInnerChapter
		})
		this.changeinnerChapter(goToInnerChapter);
	}

	componentDidMount(){

		if(_assets.isTwitter){
			console.log('%cisTwitter', 'font-weight: bolder; color: #ff0000;');

			return false;
		}

		let id = window.location.hash;
    if(id != ''){
      id = id.replace('#', '');
      
      this.setHash(id);
      this.getInnerChapterFromHash(id);
    }

		if(!this.props.firstSession && !this.props.secondSession){
			//console.log('not loaded yet', this.props.firstSession,this.props.secondSession);
			this.setState({
				innerChapter : 'load',
				currentInnerChapterTime : 0,
			});
		}


	}

	mainPlay(){

		//console.log('mainPlay')
		this.setState({
			isPlaying : true,
			isPaused : false
		});
	}

	mainPause(){
		//console.log('mainPause');
		this.setState({
			isPlaying : false,
			isPaused : true
		});
	}

	changeActiveVideo(activeVideo,videoElement){
		//console.log('changeActiveVideo', activeVideo);
		this.setState({
			activeVideo : activeVideo,
			showNote : false
		});
	}

	getCurrentTimeCode(timecode){
		this.setState({
			timecode : timecode
		});

	}

	timeUpdate(video){
		this.setState({
			currentInnerChapterTime : (video.currentTime * 100 / video.duration).toFixed(2),
			timecode : video.currentTime,
			offsettime : (video.duration / 2)
		});		
	}

	ended(){
		console.log('ende', this.state.innerChapter);
		if(this.state.innerChapter == 2){
			browserHistory.push('outro');
		}else{
			if(this.state.innerChapter != 4){
				this.changeinnerChapter();
			}else{
				console.log('ende');
			}
		}
	}

	

	changeinnerChapter(iWantChapter){

		//console.log('iWantChapter', iWantChapter);
		let currentChapter = this.state.innerChapter;
		
		if(typeof iWantChapter == "undefined"){
			//go to next chapter
			currentChapter++;
		}else{
			currentChapter = iWantChapter;
		}

		if(iWantChapter === 3){
			browserHistory.push('outro');
		}else{
			this.setHash(currentChapter);
		}

		//set autoplay 
		let autoPlay = true;
		
		//jump to chapter but it is not loaded
		if(!this.props.firstSession || !this.props.secondSession){

			//console.log('currentChapter not loaded ', currentChapter);

			this.setState({
				innerChapter : 'load',
				currentInnerChapterTime : 0,
				goToChapterAfterLoading : currentChapter,
				autoplay : false
			});
		}else{

			this.setState({
				innerChapter : currentChapter,
	    	currentInnerChapterTime : 0,
	    	timecode : 0,
	    	autoplay:autoPlay,
	    	isPlaying : autoPlay,
	    	isPaused : false
			});
		}
	}

	goToInnerChapterAfterLoad(){
		//console.log(this.state.goToChapterAfterLoading);
		if(_assets.isMobile){
			//console.log('go to mobile chapter after load: ', this.state.goToChapterAfterLoading);
			this.setState({
				innerChapter : 'mobile',
		  	currentInnerChapterTime : 0,
		  	isPlaying : false,
		  	isPaused : false
			});
		}else{
			//console.log('go to chapter after load: ', this.state.goToChapterAfterLoading)
			this.setState({
				innerChapter : this.state.goToChapterAfterLoading,
		  	currentInnerChapterTime : 0,
		  	isPlaying : false,
		  	isPaused : false
			});
		}
	}

	goToInnerChapter(event){
		let currentChapter = parseFloat( event.target.dataset.name );
		this.changeinnerChapter(currentChapter);
	}

	render(){
		const innerChapter = (<GetInnerChapter 
									key={"innerChapter-" + this.state.innerChapter}
									chapter={ this.state.innerChapter } 
									timeupdate={ this.timeUpdate.bind(this)}
									changeActiveVideo = { (activeVideo, video)=>this.changeActiveVideo(activeVideo, video) }
									changeinnerChapter={ (chapter)=>this.changeinnerChapter(chapter) }
									currentInnerChapterTime={ this.state.currentInnerChapterTime }
									activeVideo={ this.state.activeVideo }
									ended={ ()=>this.ended() }
									timecode={this.state.timecode }

									showNote={ this.state.showNote }
									//
									isPlaying={ this.state.isPlaying }
									mainPlay ={ this.mainPlay.bind(this) }
									getCurrentTimeCode={ ()=>this.getCurrentTimeCode() }
									//loading
									firstSession ={ this.props.firstSession }
									secondSession ={ this.props.secondSession }
									loadStatus={ this.props.loadStatus }
									wifiWasVisible = { this.props.wifiWasVisible }
									wifiAction = { this.props.wifiAction }

									goToInnerChapterAfterLoad={ ()=>this.goToInnerChapterAfterLoad() }

									ref="session" />);
		return (
			<div className="chapterContent">
					{/* 
						Twitter menu overlay 
					*/}

						{_assets.isTwitter && 
							<TwitterFallback />
						}

					{/* 
						Pause menu overlay 
					*/}
						<ReactCSSTransitionGroup
							component= "div"
								className={"pause-menu-overlay-holder isPlaying-" + this.state.isPlaying + " active-chapter-" + this.state.innerChapter}
			          transitionName="fadeDown"
			          transitionAppear={true}
     						transitionAppearTimeout={500}
			          transitionEnterTimeout={500}
			          transitionLeaveTimeout={300}>
			          { (this.state.innerChapter == 0 || this.state.innerChapter == 1 || this.state.innerChapter == 2) && !this.state.isPlaying  && 
			          	<Pause_menu play={()=>this.mainPlay()}
			          	chapter={1} />
        				}			          
        			</ReactCSSTransitionGroup>

						<ReactCSSTransitionGroup
							component= "div"
								className="absolute inner-chapter-holder"
			          transitionName="fade"
			          transitionAppear={true}
     						transitionAppearTimeout={500}
			          transitionEnterTimeout={500}
			          transitionLeaveTimeout={300}>
			          {innerChapter}
        			</ReactCSSTransitionGroup>
        		
						{/*timeline*/}
						{ !this.state.isMobile && 
							<ReactCSSTransitionGroup
								component= "div"
									className="absolute inner-intro-video"
				          transitionName="fade"
				          transitionAppear={true}
	     						transitionAppearTimeout={500}
				          transitionEnterTimeout={500}
				          transitionLeaveTimeout={300}>
				          { (this.state.innerChapter == 0 || this.state.innerChapter == 1 || this.state.innerChapter == 2 || this.state.innerChapter == 'mobile') &&
									  <nav className="main-nav">
											<div className="main-nav-inner">
												{/*<Warenkorb />*/}
												<Timeline
													goToInnerChapter={ (event)=> this.goToInnerChapter(event) }
													currentTime={ this.state.currentPercentage } 
													play={ () =>this.mainPlay() }
													pause={ () =>this.mainPause() }
													isPlaying={ this.state.isPlaying }
													innerChapter={ this.state.innerChapter }
													currentInnerChapterTime={ this.state.currentInnerChapterTime } />
												<Shareelement chapter={this.props.chapter}/>
												{/*<ChapterNavi/>*/}
											</div>
										</nav>
									}
									</ReactCSSTransitionGroup>
						}
			</div>);
	}
}

export default Chapter_One;


// WEBPACK FOOTER //
// ./src/scripts/chapter_one.js